import { ORDER_BUILDER_ROUTES } from '../../constants/order-builder-routes';
import { StepRoute } from '../../models/step-route.model';

export const rmsWay = [
  {
    name: 'views.builder.product_line',
    route: ORDER_BUILDER_ROUTES.BusinessLine,
  },
  {
    name: 'views.builder.location',
    route: ORDER_BUILDER_ROUTES.Location,
  },
  {
    name: 'views.builder.specifications',
    route: ORDER_BUILDER_ROUTES.RmsSpecification,
  },
  {
    name: 'views.builder.summary',
    route: ORDER_BUILDER_ROUTES.RmsSummary,
  },
] as StepRoute[];
